"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var notyf_1 = require("notyf");
var i18next_1 = __importDefault(require("i18next"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var notyf = new notyf_1.Notyf({
    position: {
        x: 'center',
        y: 'bottom',
    },
    dismissible: true,
    types: [
        {
            type: 'error',
            background: '#FF4A4A', // @brand-danger
            duration: 6000,
        },
        {
            type: 'success',
            background: '#64BB87', // @brand-success
            duration: 3000,
        },
    ],
});
var replace = function (originalMessage, originalOptions, error) {
    var message = originalMessage;
    var options = originalOptions;
    if (error) {
        console.error(error);
        if (!error.status || error.status < 0) {
            message = i18next_1.default.t('COMMON.NO_INTERNET_MESSAGE');
            options = {
                type: 'error',
                icon: {
                    className: 'eva-notification-heart-broken',
                    tagName: 'i',
                    color: 'white',
                },
            };
        }
        if (error.status >= 500) {
            message = i18next_1.default.t('COMMON.SERVER_ERROR_MESSAGE');
            options = { type: 'error' };
        }
    }
    return {
        message: message,
        options: options,
    };
};
var display = function (originalMessage, originalOptions, error) {
    var _a = replace(originalMessage, originalOptions, error), message = _a.message, options = _a.options;
    if (!message) {
        return;
    }
    // TO prevent XSS
    var sanitizedMsg = (0, sanitize_html_1.default)(message);
    var config = __assign(__assign({ message: sanitizedMsg }, options), { type: options.type === 'failure' ? 'error' : options.type });
    return notyf.open(config);
};
var error = function (originalMessage, error) {
    return display(originalMessage, { type: 'error' }, error);
};
var success = function (originalMessage, error) {
    return display(originalMessage, { type: 'success' }, error);
};
var Notifier = {
    display: display,
    error: error,
    success: success,
    dismiss: function (notification) {
        notyf.dismiss(notification);
    },
};
exports.default = Notifier;
